import "../../App.css";

import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Autocomplete from "../AutoComplete";
import AutocompleteForm from "../AutocompleteForms";
import Parametros from "../Parametros";
import Table from "../Table";
import UserTab from "../UserTab";
import Sidebar from "../Sidebar";
import CurrentUser from "../CurrentUser";

function DireccionCompleta(props) {
  const { history } = props;
  const [editable, setEditable] = useState("");
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  // eslint-disable-next-line
  const [paisesState, setPaisesState] = useState([]);
  const [stateUptade, setStateUpdate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [formularioGeoAdminState, setFormularioGeoAdminState] = useState({
    geoadmin1: "",
    geoadmin2: "",
    geoadmin3: "",
    geoadmin4: "",
    geoadmin5: "",
    geoadmin6: "",
    geoadmin7: "",
    geoadmin8: "",
    country: "",
  });

  // eslint-disable-next-line
  useEffect(async () => {
    let response = await fetch(
      Parametros.urlApi + "geoadmin?is_mantenedor=true",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      let responseJson = await response.json();

      setGeoAdminState(responseJson);
      setStateUpdate(responseJson);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    }

    let response2 = await fetch(Parametros.urlApi + "countries", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    });

    if (response2.status === 200 || response2.status === 201) {
      let responseJson = await response2.json();

      setPaisesState(responseJson);
    }

    // eslint-disable-next-line
  }, [update]);
  // eslint-disable-next-line
  let crearGeoadmin = async (e) => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      e.preventDefault();
      let formulario = JSON.parse(JSON.stringify(formularioGeoAdminState));

      paisesState.map((item) => {
        if (formularioGeoAdminState.country === item.isocode3) {
          formulario.country = item.country_id;

          return item;
        } else {
          return item;
        }
      });

      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(Parametros.post + "geoadmin/", {
          method: "POST",
          body: JSON.stringify(formulario),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setFormularioGeoAdminState({
            geoadmin1: "",
            geoadmin2: "",
            geoadmin3: "",
            geoadmin4: "",
            geoadmin5: "",
            geoadmin6: "",
            geoadmin7: "",
            geoadmin8: "",
            country: "",
          });
          setUpdate(!update);

          alert(responseJson.message);
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };
  let handleChangeFormulario = (e, formulario) => {
    e.preventDefault();
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    //
    setFormularioGeoAdminState({
      ...formularioGeoAdminState,
      [name]: value,
    });
  };
  const [geoAdminState, setGeoAdminState] = useState([]);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });

  let geoadminHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = geoAdminState;
    newList[index][name] = value;
    setGeoAdminState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };

  let cancelarEdicion = () => {
    setGeoAdminState(JSON.parse(JSON.stringify(stateUptade)));
    setEditable({});
    setformularioUpdate({});
  };
  let editar = (id) => {
    setGeoAdminState(JSON.parse(JSON.stringify(stateUptade)));
    setEditable(id);
    setformularioUpdate({});
  };
  let guardarUnidadEditada = async (item, index) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      // formularioUpdate

      if (window.confirm("¿Esta seguro de editar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react
        // if (responseJson.user_id) {

        let response = await fetch(Parametros.urlApi + "geoadmin", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify(formularioUpdate),
        });

        if (response.status === 200 || response.status === 201) {
          let responseJson = await response.json();

          setformularioUpdate({});
          setUpdate(update);
          setEditable({});
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        }

        // } else {
        //     // Do nothing!
        //     setGeoAdminState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
        // }

        // setEditable({})
      }
    } else {
      alert(usuario.editar);
    }
  };
  let formulario = (
    <form id="formularioBusqueda" onSubmit={crearGeoadmin}>
      <div className="col-md-4">
        <h5>Zona</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin1}
          name="geoadmin1"
          required
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Region</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin2}
          name="geoadmin2"
          required
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Provincia</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin3}
          name="geoadmin3"
          required
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Cuidad</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin4}
          name="geoadmin4"
          required
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Comuna</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin5}
          name="geoadmin5"
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Zona 1</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin6}
          name="geoadmin6"
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Zona 2</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin7}
          name="geoadmin7"
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Zona 3</h5>
        <input
          onChange={handleChangeFormulario}
          value={formularioGeoAdminState.geoadmin8}
          name="geoadmin8"
          className="form-control"
        ></input>
      </div>

      <div className="col-md-4">
        <h5>Pais</h5>
        <AutocompleteForm
          personalHandleChange={handleChangeFormulario}
          nameElement={"country"}
          formularioBuscado={formularioGeoAdminState}
          setformulario={setFormularioGeoAdminState}
          required={true}
          value={formularioGeoAdminState.country}
          suggestions={paisesState.map((item) => {
            return { value: item.country_id, label: item.isocode3 };
          })}
        />
      </div>

      <div className="col-md-3">
        <br />
        <button
          type="submit"
          style={{ margin: "14px 0px" }}
          id="btnBuscar"
          className="form-control button brEdit btn-primary"
        >
          Agregar
        </button>
      </div>
    </form>
  );

  return (
    <div className={props.sideBar ? "App" : ""}>
      {props.sideBar ? <Sidebar tipo="2"></Sidebar> : <></>}
      <br />
      <div className={props.sideBar ? "container" : ""}>
        {props.userTab ? <UserTab nombre={"Localizaciones"}></UserTab> : <></>}
        {formulario}

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(geoAdminState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={[
              "País",
              "Zona",
              "Region",
              "Provincia",
              "Cuidad",
              "Comuna",
              "Zona 1",
              "Zona 2",
              "Zona 3",
            ]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              elementos={[
                "País",
                "Zona",
                "Region",
                "Provincia",
                "Cuidad",
                "Comuna",
                "Zona 1",
                "Zona 2",
                "Zona 3",
              ]}
            ></Table>
            {!usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {geoAdminState
                  .slice(
                    (paginacionState.skip - 1) * paginacionState.limit,
                    (paginacionState.skip - 1) * paginacionState.limit +
                      paginacionState.limit
                  )
                  .map((item, displayIndex) => {
                    const index =
                      (paginacionState.skip - 1) * paginacionState.limit +
                      displayIndex;
                    return (
                    <tr key={item.geoadmin_zone_id}>
                      {editable === item.geoadmin_zone_id ? (
                        <>
                          <td>{item.geoadmin_zone_id}</td>
                          <td>
                            <Autocomplete
                              name={"country"}
                              suggestions={paisesState.map((pais) => {
                                return {
                                  value: pais.country_id,
                                  label: pais.name,
                                };
                              })}
                              i={index}
                              value={item.country}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              setState={setGeoAdminState}
                              state={geoAdminState}
                            ></Autocomplete>
                          </td>

                          <td>
                            <input
                              value={item.geoadmin1}
                              name="geoadmin1"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin2}
                              name="geoadmin2"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin3}
                              name="geoadmin3"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin4}
                              name="geoadmin4"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin5}
                              name="geoadmin5"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin6}
                              name="geoadmin6"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin7}
                              name="geoadmin7"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.geoadmin8}
                              name="geoadmin8"
                              onChange={(event) => {
                                geoadminHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  guardarUnidadEditada(item, index);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion();
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.geoadmin_zone_id}</td>
                          <td>
                            {paisesState.map((pais) => {
                              if (pais.country_id === item.country) {
                                return pais.name;
                              } else {
                                return "";
                              }
                            })}
                          </td>
                          <td>{item.geoadmin1}</td>
                          <td>{item.geoadmin2}</td>
                          <td>{item.geoadmin3}</td>
                          <td>{item.geoadmin4}</td>
                          <td>{item.geoadmin5}</td>
                          <td>{item.geoadmin6}</td>
                          <td>{item.geoadmin7}</td>
                          <td>{item.geoadmin8}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.geoadmin_zone_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            {/* <abbr title="Eliminar Elemento"><span style={{ cursor: "pointer" }} onClick={() => { eliminarElemento(index, item) }} className='glyphicon glyphicon-remove'></span></abbr> */}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(geoAdminState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(DireccionCompleta);
